/* ============================================================================
   ToutEn3D — CHORÉGRAPHIE (t3d-motion.js)
   Fichier update-safe. Aucun fichier Dawn n'est modifié.

   Règles tenues :
   - aucun listener "scroll" continu (IntersectionObserver uniquement)
   - on n'anime que transform et opacity
   - ce qui est visible au chargement n'est JAMAIS animé
   - sans JS ou en cas d'erreur, la page reste entièrement visible
   - prefers-reduced-motion coupe tout
   - pas d'antislash dans ce fichier : l'échappement casse la mise en ligne
   ========================================================================== */
(function () {
  'use strict';

  var doc  = document;
  var root = doc.documentElement;

  root.classList.add('t3d-js');

  var REDUCED = window.matchMedia &&
                window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var HAS_IO  = 'IntersectionObserver' in window;

  /* Réglages exposés dans l'éditeur de thème par sections/t3d-premium.liquid */
  var CFG = window.T3D_MOTION || {};

  /* ------------------------------------------------------------------
     1. État de défilement de l'en-tête
  ------------------------------------------------------------------ */
  function headerState() {
    if (!HAS_IO) { root.setAttribute('data-t3d-scroll', 'scrolled'); return; }

    var sentinel = doc.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText =
      'position:absolute;top:0;left:0;width:1px;height:1px;pointer-events:none;';
    doc.body.prepend(sentinel);

    new IntersectionObserver(function (entries) {
      root.setAttribute(
        'data-t3d-scroll',
        entries[0].isIntersecting ? 'top' : 'scrolled'
      );
    }, { threshold: 0 }).observe(sentinel);
  }

  /* ------------------------------------------------------------------
     2. Révélations au scroll
  ------------------------------------------------------------------ */
  var SKIP = [
    '.header-wrapper', '.header', '.footer', '.footer-block',
    'cart-drawer', 'cart-notification', '.cart-notification',
    '.t3d-h3', '.t3d-marquee', '.announcement-bar',
    '.product', '.facets-wrapper', '#FacetsWrapperDesktop',
    '.shopify-payment-button', '.quick-add', '.modal__content',
    '[data-t3d-no-reveal]'
  ].join(',');

  var SKIP_SECTION_ID = /(config|cdc|outil|track123|cart|announcement)/i;

  var CANDIDATES = [
    'h1', 'h2', 'h3', 'h4',
    'p', 'ul', 'ol', 'blockquote', 'figure', 'picture', 'video', 'table',
    'img',
    '[class*="__eyebrow"]', '[class*="__cta-wrap"]', '[class*="__actions"]',
    '[class*="__card"]', '[class*="__item"]', '[class*="__media"]',
    '[class*="__img"]', '[class*="__specs"]',
    '[class*="__tile"]', '[class*="__col"]',
    '.card-wrapper', '.t3d-btn', '.button'
  ].join(',');

  /* Une bande pleine largeur ne s'anime jamais en bloc : c'est lourd à
     composer et ça donne l'impression d'une page qui charge. Ce sont ses
     contenus qui entrent. */

  var MEDIA_RE = /(__media|__img|__visual|__photo)/;

  var observer = null;

  function makeObserver() {
    if (!HAS_IO) return null;
    return new IntersectionObserver(function (entries, obs) {
      for (var i = 0; i < entries.length; i++) {
        var e = entries[i];
        if (!e.isIntersecting) {
          /* Déjà dépassé (ancre, retour arrière, position restaurée) :
             on le montre tout de suite, il ne repassera jamais. */
          if (e.boundingClientRect.bottom < 0) {
            show(e.target);
            obs.unobserve(e.target);
          }
          continue;
        }
        show(e.target);
        obs.unobserve(e.target);
      }
    }, {
      rootMargin: '0px 0px -12% 0px',
      threshold: 0.01
    });
  }

  function show(el) {
    el.classList.add('t3d-in');
    var clean = function () {
      el.removeAttribute('data-t3d-reveal');
      el.removeAttribute('data-t3d-media');
      el.classList.remove('t3d-in');
      el.style.removeProperty('--t3d-rv-delay');
      el.style.removeProperty('--t3d-rv-blur');
      el.style.removeProperty('--t3d-rv-y');
      el.style.removeProperty('will-change');
    };
    el.addEventListener('transitionend', function h(ev) {
      if (ev.target !== el || ev.propertyName !== 'transform') return;
      el.removeEventListener('transitionend', h);
      clean();
    });
    setTimeout(clean, 2200);
  }

  function annotate(scope) {
    if (REDUCED || !observer || CFG.reveals === false) return;

    var sections = (scope || doc).querySelectorAll('.shopify-section');

    for (var s = 0; s < sections.length; s++) {
      var section = sections[s];
      if (SKIP_SECTION_ID.test(section.id || '')) continue;
      if (section.closest(SKIP)) continue;

      var found = section.querySelectorAll(CANDIDATES);
      if (!found.length) continue;

      var picked = [];
      var set = new Set(found);

      for (var i = 0; i < found.length; i++) {
        var el = found[i];
        if (el.closest(SKIP)) continue;
        if (el.hasAttribute('data-t3d-reveal')) continue;

        var parent = el.parentElement, nested = false;
        while (parent && parent !== section) {
          if (set.has(parent)) { nested = true; break; }
          parent = parent.parentElement;
        }
        if (nested) continue;

        var pos = getComputedStyle(el).position;
        if (pos === 'fixed' || pos === 'sticky') continue;
        if (!el.getClientRects().length) continue;

        picked.push(el);
      }

      var counters = new Map();
      var vh = window.innerHeight;

      for (var j = 0; j < picked.length; j++) {
        var node = picked[j];
        var box = node.getBoundingClientRect();

        /* RÈGLE PREMIÈRE : ce qui est visible au chargement n'est pas animé. */
        if (box.top < vh) continue;

        var key = node.parentElement;
        var n = counters.get(key) || 0;
        counters.set(key, n + 1);

        node.setAttribute('data-t3d-reveal', '');
        if (MEDIA_RE.test(node.className || '') || node.tagName === 'IMG' ||
            node.tagName === 'FIGURE' || node.tagName === 'PICTURE') {
          node.setAttribute('data-t3d-media', '');
        }
        if (n > 0) {
          node.style.setProperty('--t3d-rv-delay', Math.min(n, 8) * 70 + 'ms');
        }
        if (box.height > vh * 0.6) {
          node.style.setProperty('--t3d-rv-blur', '0px');
          node.style.setProperty('--t3d-rv-y', '16px');
        }

        observer.observe(node);
      }
    }
  }

  /* La mise en page n'est pas figée à DOMContentLoaded : les polices, les
     images et les applications tierces la déplacent encore. On repasse donc
     plusieurs fois après coup et on rend visible, SANS animation, tout ce qui
     se retrouve dans l'écran. */
  function settleAboveFold() {
    var vh = window.innerHeight || 0;
    if (!vh) return;

    var list = doc.querySelectorAll('[data-t3d-reveal]:not(.t3d-in)');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (el.getBoundingClientRect().top >= vh) continue;

      if (observer) observer.unobserve(el);
      el.removeAttribute('data-t3d-reveal');
      el.removeAttribute('data-t3d-media');
      el.style.removeProperty('--t3d-rv-delay');
      el.style.removeProperty('--t3d-rv-blur');
      el.style.removeProperty('--t3d-rv-y');
      el.style.removeProperty('will-change');
    }
  }

  function failsafe() {
    setTimeout(function () {
      var hidden = doc.querySelectorAll('[data-t3d-reveal]:not(.t3d-in)');
      for (var i = 0; i < hidden.length; i++) {
        var el = hidden[i];
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 1.2) show(el);
      }
    }, 4000);
  }

  /* ------------------------------------------------------------------
     3. Images : fondu au décodage, plus de "pop-in"
  ------------------------------------------------------------------ */
  function imageFade(scope) {
    if (REDUCED) return;
    var imgs = (scope || doc).querySelectorAll(
      '.card__media img, .card .media img, [class*="t3d-"] img'
    );
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.hasAttribute('data-t3d-fade')) continue;
      if (img.closest('.header, .footer, .t3d-marquee')) continue;
      if (img.complete && img.naturalWidth > 0) continue;

      img.setAttribute('data-t3d-fade', '');
      (function (node) {
        var done = function () { node.classList.add('t3d-loaded'); };
        node.addEventListener('load', done, { once: true });
        node.addEventListener('error', done, { once: true });
        setTimeout(done, 3000);
      })(img);
    }
  }

  /* ------------------------------------------------------------------
     4. CTA magnétique — souris de précision uniquement
  ------------------------------------------------------------------ */
  function magnetic() {
    if (REDUCED || CFG.magnetic === false) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    /* Le lien de l'outil cahier des charges porte la meme pastille que Devis. */
    var targets = doc.querySelectorAll(
      '.t3d-btn--action, .t3d-cta--solid, .header a[href*="devis-impression-3d"], ' +
      '.header a[href$="/pages/cdc"]'
    );

    for (var i = 0; i < targets.length; i++) {
      (function (btn) {
        if (btn.dataset.t3dMag) return;
        btn.dataset.t3dMag = '1';
        var raf = null;

        btn.addEventListener('pointermove', function (e) {
          if (raf) return;
          raf = requestAnimationFrame(function () {
            raf = null;
            var r = btn.getBoundingClientRect();
            var dx = (e.clientX - (r.left + r.width / 2)) / r.width;
            var dy = (e.clientY - (r.top + r.height / 2)) / r.height;
            btn.style.setProperty('--t3d-mag-x', (dx * 6).toFixed(2) + 'px');
            btn.style.setProperty('--t3d-mag-y', (dy * 4).toFixed(2) + 'px');
          });
        });

        btn.addEventListener('pointerleave', function () {
          btn.style.setProperty('--t3d-mag-x', '0px');
          btn.style.setProperty('--t3d-mag-y', '0px');
        });
      })(targets[i]);
    }
  }

  /* ------------------------------------------------------------------
     5. Habillage : grain + barre de progression
  ------------------------------------------------------------------ */
  function chrome() {
    if (CFG.grain !== false && !doc.querySelector('.t3d-grain')) {
      var grain = doc.createElement('div');
      grain.className = 't3d-grain';
      grain.setAttribute('aria-hidden', 'true');
      doc.body.appendChild(grain);
    }

    var supportsTimeline = window.CSS && CSS.supports &&
                           CSS.supports('animation-timeline', 'scroll()');
    if (supportsTimeline && !REDUCED && !doc.querySelector('.t3d-progress')) {
      var bar = doc.createElement('div');
      bar.className = 't3d-progress';
      bar.setAttribute('aria-hidden', 'true');
      doc.body.appendChild(bar);
    }
  }

  /* ------------------------------------------------------------------
     6. Barre d'achat collante (fiche produit, téléphone)
     Le clic déclenche le VRAI bouton du formulaire Dawn : variante, quantité
     et validations restent celles du thème, on ne réimplémente rien.

     Fiche produit UNIQUEMENT : sur une collection, le premier formulaire
     d'ajout trouvé était celui d'une carte (ajout rapide), d'où une barre
     « Collection… / Ajouter au panier Épuisé » hors de propos.

     Paliers et « Complète ton achat » (assets/t3d-bundles.js) : ils réécrivent
     le libellé du vrai bouton (« · 3 articles », « Répartis encore… ») et
     diffusent le total de la sélection par l'événement t3d:buybox (dernier
     état gardé dans window.T3D_BUYBOX). La barre reprend les deux.
  ------------------------------------------------------------------ */
  function mainBuyButton() {
    var list = doc.querySelectorAll('product-form [type="submit"]');
    for (var i = 0; i < list.length; i++) {
      var b = list[i];
      if (b.closest('.card-wrapper, quick-add-modal, .quick-add, cart-drawer, .t3d-buybar')) continue;
      if (!b.closest('[id^="MainProduct-"]')) continue;
      return b;
    }
    return null;
  }

  /* Le bouton Dawn contient aussi des textes masqués (chargement, épuisé) :
     on ne lit que son libellé visible. */
  function buttonLabel(b) {
    var s = b.querySelector('span:not(.hidden):not(.sold-out-message)');
    return ((s ? s.textContent : b.textContent) || 'Ajouter au panier').trim();
  }

  /* Prix affiché par Dawn : le prix barré n'existe que si .price--on-sale. */
  function shownPrice(scope) {
    var box = scope.querySelector('[id^="price-"] .price') || scope.querySelector('.price');
    if (!box) return '';
    var p = box.classList.contains('price--on-sale') ?
            box.querySelector('.price__sale .price-item--sale') :
            box.querySelector('.price__regular .price-item--regular');
    return p ? p.textContent.trim() : '';
  }

  function buyBar() {
    if (!HAS_IO) return;
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    var main = doc.querySelector('main[data-template]');
    if (!main || main.getAttribute('data-template') !== 'product') return;

    var realBtn = mainBuyButton();
    /* .product__title est un conteneur qui répète le titre (h1 + lien) :
       on prend le h1, sinon la barre affiche le nom deux fois. */
    var titleEl = doc.querySelector('.product__title h1') ||
                  doc.querySelector('h1.product__title') ||
                  doc.querySelector('.product__info-container h1') ||
                  doc.querySelector('h1');
    if (!realBtn || !titleEl) return;
    if (doc.querySelector('.t3d-buybar')) return;

    var bar = doc.createElement('div');
    bar.className = 't3d-buybar';
    bar.innerHTML =
      '<span class="t3d-buybar__txt">' +
        '<span class="t3d-buybar__title"></span>' +
        '<span class="t3d-buybar__price"></span>' +
      '</span>' +
      '<button type="button" class="t3d-buybar__btn"></button>';
    doc.body.appendChild(bar);
    root.classList.add('t3d-has-buybar');

    var btn = bar.querySelector('.t3d-buybar__btn');
    var priceEl = bar.querySelector('.t3d-buybar__price');
    bar.querySelector('.t3d-buybar__title').textContent = titleEl.textContent.trim();

    function sync() {
      var state = window.T3D_BUYBOX;
      priceEl.textContent = '';
      if (state && state.price) {
        priceEl.appendChild(doc.createTextNode(state.price));
        if (state.was) {
          var was = doc.createElement('s');
          was.textContent = state.was;
          was.style.cssText = 'margin-left:.6rem;font-size:1.28rem;font-weight:500;color:#6B7280;';
          priceEl.appendChild(was);
        }
      } else {
        priceEl.textContent = shownPrice(realBtn.closest('[id^="MainProduct-"]') || doc);
      }
      btn.textContent = buttonLabel(realBtn);
      btn.disabled = !!realBtn.disabled;
    }

    /* Le vrai bouton change de libellé ou d'état (variante épuisée,
       chargement, paliers) : la barre suit, sans minuterie. */
    var watch = new MutationObserver(sync);
    var io = new IntersectionObserver(function (e) {
      bar.classList.toggle('is-on', !e[e.length - 1].isIntersecting);
    }, { threshold: 0 });

    function bind(b) {
      if (realBtn) io.unobserve(realBtn);
      realBtn = b;
      watch.disconnect();
      watch.observe(realBtn, { attributes: true, childList: true, subtree: true, characterData: true });
      /* Une seule condition, aucun listener de défilement : la barre apparaît
         dès que le vrai bouton n'est plus à l'écran, et disparaît quand il
         revient. */
      io.observe(realBtn);
      sync();
    }
    bind(realBtn);

    /* Au changement de variante, Dawn remplace toute la zone produit
       (nouvelle zone insérée, ancienne retirée 500 ms plus tard) : on se
       raccroche au nouveau bouton. */
    function rebind() {
      var b = mainBuyButton();
      if (b && b !== realBtn) bind(b);
      else sync();
    }
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        setTimeout(rebind, 50);
        setTimeout(rebind, 650);
      });
    }
    doc.addEventListener('t3d:buybox', sync);
    doc.addEventListener('change', function () { setTimeout(sync, 400); });

    btn.addEventListener('click', function () {
      var state = window.T3D_BUYBOX;
      /* Palier incomplet : le message s'affiche dans le bloc, hors de l'écran.
         On y emmène le client plutôt que de cliquer dans le vide. */
      if (state && state.missing > 0) {
        var pal = doc.querySelector('t3d-paliers');
        if (pal) pal.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'center' });
      }
      realBtn.click();
    });
  }

  /* ------------------------------------------------------------------
     7. Lien « Boutique » du menu → la landing dessinée
     Le menu de navigation est une ressource GLOBALE au magasin : le modifier
     toucherait le site en ligne, où /pages/boutique ne rend que trois lignes.
     On réécrit donc le lien côté thème, sur ce thème-ci uniquement. Le menu du
     magasin reste intact. À la publication, repointer le vrai menu et couper
     ce réglage.
  ------------------------------------------------------------------ */
  function menuRewrite() {
    var from = (CFG.menuFrom || '').trim();
    var to   = (CFG.menuTo || '').trim();
    if (!from || !to) return;

    /* Pas de regex ici : l'échappement de l'antislash est une source d'erreurs
       au moment de pousser le fichier. Boucle simple, même résultat. */
    var norm = function (u) {
      u = (u || '').split('?')[0].split('#')[0];
      while (u.length > 1 && u.charAt(u.length - 1) === '/') u = u.slice(0, -1);
      return u || '/';
    };
    var cible = norm(from);

    var liens = doc.querySelectorAll(
      '.header__menu-item, .menu-drawer__menu-item, .header__submenu a, .menu-drawer__menu a'
    );
    for (var i = 0; i < liens.length; i++) {
      var a = liens[i];
      if (norm(a.getAttribute('href')) !== cible) continue;
      a.setAttribute('href', to);
      if (norm(location.pathname) === norm(to)) {
        a.setAttribute('aria-current', 'page');
      }
    }
  }

  /* ------------------------------------------------------------------
     8. Étiquettes de formulaire non reliées à leur champ
     Le configurateur de devis affiche bien « Email * » au-dessus du champ,
     mais le <label> n'a pas d'attribut for : rien ne les relie. Un lecteur
     d'écran n'annonce donc aucun nom, et cliquer sur l'étiquette ne place pas
     le curseur dans le champ, ce qui prive le doigt d'une cible sur mobile.
     On les relie ici, sans toucher à la section de 243 Ko.
  ------------------------------------------------------------------ */
  var NOMS_ORPHELINS = {
    'file-input': 'Déposer un fichier 3D (STL, STP, STEP, OBJ, 3MF, SVG)',
    'qty-range': 'Quantité'
  };

  function labelFix(scope) {
    var racine = scope || doc;
    var uid = 0;

    var labels = racine.querySelectorAll('label:not([for])');
    for (var i = 0; i < labels.length; i++) {
      var lab = labels[i];
      /* Étiquette qui enveloppe déjà son champ : elle est valide, on passe. */
      if (lab.querySelector('input, select, textarea')) continue;

      var champ = lab.nextElementSibling;
      if (!champ) continue;
      if (champ.tagName !== 'INPUT' && champ.tagName !== 'SELECT' &&
          champ.tagName !== 'TEXTAREA') continue;

      var t = (champ.type || '').toLowerCase();
      if (t === 'hidden' || t === 'submit' || t === 'button' || t === 'image') continue;

      if (!champ.id) champ.id = 't3d-champ-' + (++uid);
      lab.setAttribute('for', champ.id);
    }

    /* Restent les commandes qui n'ont aucune étiquette du tout. */
    for (var cle in NOMS_ORPHELINS) {
      if (!Object.prototype.hasOwnProperty.call(NOMS_ORPHELINS, cle)) continue;
      var el = racine.querySelector('#' + cle);
      if (el && !el.getAttribute('aria-label')) {
        el.setAttribute('aria-label', NOMS_ORPHELINS[cle]);
      }
    }
  }

  /* ------------------------------------------------------------------
     Démarrage
  ------------------------------------------------------------------ */
  function boot() {
    try {
      observer = makeObserver();
      headerState();
      chrome();
      annotate(doc);
      imageFade(doc);
      magnetic();
      buyBar();
      menuRewrite();
      labelFix(doc);

      /* Quatre points de contrôle : trame suivante, polices chargées, page
         complète, puis un dernier filet. */
      requestAnimationFrame(settleAboveFold);
      if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(settleAboveFold);
      window.addEventListener('load', settleAboveFold, { once: true });
      setTimeout(settleAboveFold, 1200);

      failsafe();
    } catch (err) {
      var hidden = doc.querySelectorAll('[data-t3d-reveal]');
      for (var i = 0; i < hidden.length; i++) {
        hidden[i].removeAttribute('data-t3d-reveal');
      }
      if (window.console) console.warn('[t3d-motion]', err);
    }
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  doc.addEventListener('shopify:section:load', function (e) {
    try {
      annotate(e.target);
      imageFade(e.target);
      magnetic();
      menuRewrite();
      labelFix(e.target);
      requestAnimationFrame(settleAboveFold);
    } catch (err) {}
  });
})();